module.exports = __webpack_public_path__ + "img/photo2_3.2b60eb73.jpg";